<section class="masthead-page masthead-chi-sono montserrat">
    <p class="card-text montserrat text-center">CHI SONO</p>
</section>

<section class="textblock wrapper marginauto montserrat">
    <div class="row">

        <div class="col-11 pt-5 pb-4">

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/"><i class="fa fa-home" aria-hidden="true"></i> Home</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Chi Sono</li>
                </ol>
            </nav>

        </div>

    </div>
</section>

<section class="textblock wrapper marginauto montserrat">
    <div class="col-11 mt-3 marginauto">
        <div class="text text-justify pb-3">
                <div class="row alimentarsi-oggi montserrat">
                    <div class="col">
                        <p>Il dottor <b>Riccardo Ferrero Leone</b> è medico chirurgo e si dedica alla nutrizione clinica da oltre due decenni per il controllo del peso e delle patologie correlate, fisiche e comportamentali.</p>

                        <p>È docente a contratto in Nutrizione Clinica e Medicina Integrata all’Università “Sapienza” di Roma, Master 2° livello, Facoltà di Farmacia e Medicina.</p>

                        <p>Dal 1981 ha integrato gli studi universitari con le discipline di medicina non convenzionale, dall’agopuntura alla fitoterapia e ha approfondito la conoscenza del comportamento umano attraverso l’ipnosi ericksoniana e la programmazione neurolinguistica.</p>

                        <p>Segue i suoi pazienti da un punto di vista prettamente medico nonché come guida comportamentale e nei percorsi di autostima e crescita personale; il suo approccio globale al benessere della persona data anni prima delle tendenze attualmente più in voga (es. biohacking).</p>

                        <p>Il dottor Riccardo Ferrero Leone visita a Roma in via Montagne Rocciose 60, Studio TekneMedica, tel. 06 45441960 e segue molti pazienti on-line in Italia e nel resto del mondo (mail a <a href="mailto:nutrizioneferrero@gmail.com">nutrizioneferrero@gmail.com</a>)</p>

                        <p>È influencer in nutrizione e dieta chetogenica, questi i principali canali social:</p>
                        <ul>
                            <li>
                                <a href="https://www.facebook.com/groups/1163803047126402" target="_blank">www.facebook.com/groups/1163803047126402</a>
                            </li>

                            <li>
                                <a href="https://www.facebook.com/groups/235647650294978" target="_blank">www.facebook.com/groups/235647650294978</a>
                            </li>

                            <li>
                                <a href="https://www.facebook.com/docriccardo" target="_blank">www.facebook.com/docriccardo</a>
                            </li>

                            <li>
                                <a href="https://www.instagram.com/riccardo.ferrero.leone/" target="_blank">www.instagram.com/riccardo.ferrero.leone/</a> 
                            </li>

                            <li>
                                <a href="https://www.youtube.com/channel/UCWBXZGb94LVb97LmFSOf2SA" target="_blank">www.youtube.com/channel/UCWBXZGb94LVb97LmFSOf2SA</a> 
                            </li>
                        </ul>
                    </div>
                </div>

        </div>
    </div>

    <div class="col-11 pt-5 pb-4">

        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/">Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">Chi Sono</li>
            </ol>
        </nav>

    </div>


</section>

<section class="py-3"></section>
